"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetReservationCache = exports.createReservation = exports.cacheReservation = exports.RESET_RESERVATION_CACHE = exports.CREATE_RESERVATION = exports.CACHE_RESERVATION = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reduxActions = require("redux-actions");

var _env = require("../env");

var _ajax = require("./ajax");

var _httpActions = require("./http-actions");

var CREATE_RESERVATION = 'MANUAL_NOTARY_CREATE_RESERVATION';
exports.CREATE_RESERVATION = CREATE_RESERVATION;
var CACHE_RESERVATION = 'MANUAL_NOTARY_CACHE_RESERVATION';
exports.CACHE_RESERVATION = CACHE_RESERVATION;
var RESET_RESERVATION_CACHE = 'MANUAL_NOTARY_RESET_RESERVATION_CACHE';
exports.RESET_RESERVATION_CACHE = RESET_RESERVATION_CACHE;
var HELOC_CONTEXT = '/service-application/api/v1/application/heloc';
var MERLOC_CONTEXT = '/app-merloc/secure/api/v1/application/heloc';
var CONTEXT = _env.isMerchant ? MERLOC_CONTEXT : HELOC_CONTEXT;
var cacheReservation = (0, _reduxActions.createAction)(CACHE_RESERVATION);
exports.cacheReservation = cacheReservation;
var resetReservationCache = (0, _reduxActions.createAction)(RESET_RESERVATION_CACHE); // { helocUuid, reservationTime, reservationAddress, contactNumber }

exports.resetReservationCache = resetReservationCache;

var createReservation = function createReservation(data) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxPut)(CREATE_RESERVATION, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/manual-notary"), data));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.createReservation = createReservation;